// Generated by purs version 0.15.0
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Result from "../Data.Result/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Coupons_Types from "../Restaumatic.Coupons.Types/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var GetActivePromotionsRequest = function (x) {
    return x;
};
var InvalidCoupon = /* #__PURE__ */ (function () {
    function InvalidCoupon() {

    };
    InvalidCoupon.value = new InvalidCoupon();
    return InvalidCoupon;
})();
var CouponPromotion = function (x) {
    return x;
};
var GetActivePromotionsResponseContent = function (x) {
    return x;
};
var GetActivePromotionsResponse = function (x) {
    return x;
};
var rPCMethodNameGetActivePro = {
    rpcMethodName: function (v) {
        return "GetActivePromotionsRequest";
    }
};
var newtypeGetActivePromotion = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetActivePromotion1 = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetActivePromotion2 = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCouponPromotion_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetActivePromotio = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetActivePromotio1 = function (dictHasField) {
    return dictHasField;
};
var hasFieldCouponPromotion = function (dictHasField) {
    return dictHasField;
};
var eqGetActivePromotionsRequ = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.couponCodes)(y.couponCodes) && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId);
        };
    }
};
var eqGetActivePromotionsErro = {
    eq: function (x) {
        return function (y) {
            return true;
        };
    }
};
var ordGetActivePromotionsErr = {
    compare: function (x) {
        return function (y) {
            return Data_Ordering.EQ.value;
        };
    },
    Eq0: function () {
        return eqGetActivePromotionsErro;
    }
};
var eqCouponPromotion = {
    eq: function (x) {
        return function (y) {
            return x.code === y.code && Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(x.promotionId)(y.promotionId) && Data_Eq.eq(Restaumatic_Coupons_Types.eqCouponSource)(x.source)(y.source);
        };
    }
};
var eqGetActivePromotionsResp = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(eqCouponPromotion))(x.coupons)(y.coupons) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Promotions_Types.eqPromotion))(x.promotions)(y.promotions);
        };
    }
};
var eqGetActivePromotionsResp1 = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Result.eqResult(eqGetActivePromotionsErro)(eqGetActivePromotionsResp))(x)(y);
        };
    }
};
var genericGetActivePromotionsResponseContent = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericGetActivePromotionsResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericGetActivePromotionsRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetActivePromotionsRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetActivePromotionsRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "couponCodes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Restaurant_Types_Id.showRestaurantId))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "GetActivePromotionsRequest";
        }
    }))
};
var unscrambleDecodeGetActivePromotionsRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "couponCodes";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericGetActivePromotionsError = {
    to: function (x) {
        return InvalidCoupon.value;
    },
    from: function (x) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var showGetActivePromotionsError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "InvalidCoupon";
        }
    }))
};
var unscrambleDecodeGetActivePromotionsError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericGetActivePromotionsError)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "InvalidCoupon";
        }
    }))(Unscramble_Enum.defaultEnumOptions)
};
var boundedGetActivePromotion = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments)),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)),
    Ord0: function () {
        return ordGetActivePromotionsErr;
    }
};
var enumGetActivePromotionsEr = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments)),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments)),
    Ord0: function () {
        return ordGetActivePromotionsErr;
    }
};
var boundedEnumGetActivePromo = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericGetActivePromotionsError)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)),
    Bounded0: function () {
        return boundedGetActivePromotion;
    },
    Enum1: function () {
        return enumGetActivePromotionsEr;
    }
};
var genericCouponPromotion = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCouponPromotion = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCouponPromotion)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "source";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Coupons_Types.showCouponSource))(Restaumatic_Promotions_Types_Id.showPromotionId))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CouponPromotion";
        }
    }))
};
var showGetActivePromotionsResponseContent = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotions";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Promotions_Types.showPromotion)))(/* #__PURE__ */ Data_Show.showArray(showCouponPromotion)))))({
        reflectSymbol: function () {
            return "GetActivePromotionsResponseContent";
        }
    }))
};
var showGetActivePromotionsResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetActivePromotionsResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Result.showResult(showGetActivePromotionsError)(showGetActivePromotionsResponseContent)))({
        reflectSymbol: function () {
            return "GetActivePromotionsResponse";
        }
    }))
};
var unscrambleDecodeCouponPromotion = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCouponPromotion)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "code";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(Restaumatic_Promotions_Types_Id.decodePromotionId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "source";
        }
    })(Restaumatic_Coupons_Types.unscrambleDecodeCouponSource)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeGetActivePromotionsResponseContent = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeCouponPromotion))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Promotions_Types.unscrambleDecodePromotion))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeGetActivePromotionsResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Data_Result.udecodeResult(unscrambleDecodeGetActivePromotionsError)(unscrambleDecodeGetActivePromotionsResponseContent))))(Unscramble_Generic.defaultOptions)
};
var encodeGetActivePromotionsRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
        reflectSymbol: function () {
            return "couponCodes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))))
};
var encodeGetActivePromotionsError = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericGetActivePromotionsError)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "InvalidCoupon";
        }
    }))
};
var encodeCouponPromotion = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCouponPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CouponPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Coupons_Types.encodeCouponSource)))({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_Types_Id.encodePromotionId)))({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodeGetActivePromotionsResponseContent = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsResponseContent";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Promotions_Types.encodePromotion))))({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeCouponPromotion)))))))
};
var encodeGetActivePromotionsResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Result.encodeResult(encodeGetActivePromotionsError)(encodeGetActivePromotionsResponseContent)))))
};
var decodeGetActivePromotionsRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
        reflectSymbol: function () {
            return "couponCodes";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGetActivePromotionsError = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericGetActivePromotionsError)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "InvalidCoupon";
        }
    }))
};
var decodeCouponPromotion = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCouponPromotion)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CouponPromotion";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Coupons_Types.decodeCouponSource))())({
        reflectSymbol: function () {
            return "promotionId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Promotions_Types_Id.decodePromotionId1))())({
        reflectSymbol: function () {
            return "code";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGetActivePromotionsResponseContent = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsResponseContent";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Promotions_Types.decodePromotion)))())({
        reflectSymbol: function () {
            return "coupons";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeCouponPromotion)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGetActivePromotionsResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GetActivePromotionsResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Result.decodeResult(decodeGetActivePromotionsError)(decodeGetActivePromotionsResponseContent))))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GetActivePromotionsResponseContent,
    GetActivePromotionsResponse,
    GetActivePromotionsRequest,
    InvalidCoupon,
    CouponPromotion,
    genericGetActivePromotionsResponseContent,
    eqGetActivePromotionsResp,
    showGetActivePromotionsResponseContent,
    encodeGetActivePromotionsResponseContent,
    decodeGetActivePromotionsResponseContent,
    unscrambleDecodeGetActivePromotionsResponseContent,
    hasFieldGetActivePromotio1,
    newtypeGetActivePromotion2,
    genericGetActivePromotionsResponse,
    eqGetActivePromotionsResp1,
    showGetActivePromotionsResponse,
    encodeGetActivePromotionsResponse,
    decodeGetActivePromotionsResponse,
    unscrambleDecodeGetActivePromotionsResponse,
    newtypeGetActivePromotion1,
    genericGetActivePromotionsRequest,
    eqGetActivePromotionsRequ,
    showGetActivePromotionsRequest,
    rPCMethodNameGetActivePro,
    encodeGetActivePromotionsRequest,
    decodeGetActivePromotionsRequest,
    unscrambleDecodeGetActivePromotionsRequest,
    hasFieldGetActivePromotio,
    newtypeGetActivePromotion,
    genericGetActivePromotionsError,
    eqGetActivePromotionsErro,
    showGetActivePromotionsError,
    encodeGetActivePromotionsError,
    decodeGetActivePromotionsError,
    unscrambleDecodeGetActivePromotionsError,
    ordGetActivePromotionsErr,
    enumGetActivePromotionsEr,
    boundedGetActivePromotion,
    boundedEnumGetActivePromo,
    genericCouponPromotion,
    eqCouponPromotion,
    showCouponPromotion,
    encodeCouponPromotion,
    decodeCouponPromotion,
    unscrambleDecodeCouponPromotion,
    hasFieldCouponPromotion,
    newtypeCouponPromotion_
};
//# sourceMappingURL=index.js.map
